// extracted by mini-css-extract-plugin
export default {"root":"App-root-8562271b3cbd3cc09df393ee87292ec6","container":"App-container-b0d921f7e8030e3d2058e1b70fd2d6ed"};